// @ts-nocheck
// Form state is care-type-specific (child care, companion care, pet care,
// housekeeping). The context is intentionally generic; each form casts the
// shared state to its own concrete type.
export type ProfileEditFormState = Record<string, any>;
export type ProfileEditSectionPartial = Record<string, any>;

export interface ProfileEditContext {
  careType: string;
  graphqlCareType: string;
  sitterUuid: string;
  loading: boolean;
  saving: boolean;
  saveError: string;
  getFormState: () => ProfileEditFormState | null;
  saveSection: (partial: ProfileEditSectionPartial) => Promise<void>;
  cancelEdit: () => void;
}

export default {
  inject: {
    profileEditContext: {
      default: null,
    },
  },
  computed: {
    profileEdit(): ProfileEditContext | null {
      return (this as { profileEditContext: ProfileEditContext | null }).profileEditContext;
    },
    isSaving(): boolean {
      return !!this.profileEdit?.saving;
    },
    formState(): ProfileEditFormState | null {
      return this.profileEdit?.getFormState() || null;
    },
  },
  methods: {
    async saveSection(partial: ProfileEditSectionPartial): Promise<void> {
      const profileEdit = (this as { profileEdit?: ProfileEditContext | null }).profileEdit;
      if (!profileEdit) return;
      await profileEdit.saveSection(partial);
    },
    cancelEdit(): void {
      (this as { profileEdit?: ProfileEditContext | null }).profileEdit?.cancelEdit();
    },
  },
};
